// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2nKze","alert":"SettungsInbox_alert__1cQqE"};